import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { takeWhile } from 'rxjs/operators';
import * as moment from 'moment';

import * as fromStore from '@ibe/store/index';
import * as MiniIBEActions from '@ibe/store/actions/mini-ibe.actions';
import * as ConfirmModalActions from '@ibe/store/actions/confirm-modal.actions';

import { SidebarService } from '@ibe.components/common/sidebar/sidebar.service';
import { PassengersSegmentedCount } from '@ibe/models';
import { BookingStep } from '@ibe/models/ui';
import { INDRAConfirmModalComponent } from '@ibe.components/shared/confirm-modal/confirm-modal.indra.component';
import { ModalService } from '@ibe/services/ui';
import { Stopover } from '@ibe/store/states/mini-ibe.indra.state';
import * as BookingStepsActions from '@ibe/store/actions/booking-steps.actions';
import { TRIP_TYPE_ROUND_TRIP_CODE, TRIP_TYPE_ONE_WAY_CODE, TRIP_TYPE_MULTICITY_CODE, FLIGHT_HAUL_TYPE_LONG } from '@ibe.config';
import scrollLock from 'scroll-lock';

import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRADateService } from '@ibe.services/date.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';

@Component({
	selector: 'app-edit-search',
	templateUrl: './edit-search.indra.component.html',
	styleUrls: ['./edit-search.component.scss']
})
export class EditSearchComponent implements OnInit, OnDestroy {
	htmlElement = document.getElementsByTagName('html');
	isAlive = true;
	
	searchRoutes$: Observable<Array<any>> = this.store.select(fromStore.getMiniIBESearchRoutes);
	searchRoutes: Array<any>;
	
	routeType$: Observable<string> = this.store.select(fromStore.getMiniIBERouteType);
	routeType: string;
	
	stopover$: Observable<Array<Stopover>> = this.store.select(fromStore.getMiniIBEStopovers);
	stopover: Array<Stopover>;
	hasStopover: boolean = false;

	passengers$: Observable<PassengersSegmentedCount> = this.store.select(fromStore.getMiniIBEPassengers);
	passengers: PassengersSegmentedCount;
	
	bookingSteps$: Observable<Array<BookingStep>> = this.store.select(fromStore.getSelectedBookingSteps);
	bookingSteps: Array<BookingStep> = [];

	possitiveCallback$: Observable<string> = this.store.select(fromStore.getConfirmModalConfirm);
	possitiveCallback = '';
	
	// isCorporate$: Observable<boolean> = this.store.select(fromStore.getIsCorporate);
	// isCorporate: boolean;
	dates = [];
	haulTypePerRoute = [];
	stepWithStopover;
	isStopoverAvailabilityPage: boolean = false;

	constructor(
		private router: Router,
		private store: Store<fromStore.State>,
		protected sidebarService: SidebarService,
		private modalService: ModalService,
		private bfmDataStorage: INDRABFMDataStorageService,
		private dateService: INDRADateService,
		private ibeAdminService: INDRAIbeAdminService
	) {
		if (this.router.url.includes('/flights-stopover')) {
			this.isStopoverAvailabilityPage = true;
		}
		
		/* note: from post sprint 8 merge
		this.isCorporate$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(
				value => {
					this.isCorporate = value;
				}
			);
		*/
		
		this.searchRoutes$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(
				value => {
					if (value) {
						this.searchRoutes = value;
					}
				}
			);

		this.routeType$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					switch (value) {
						case TRIP_TYPE_ROUND_TRIP_CODE:
							this.routeType = 'editSidebar.label.roundTrip';
							break;
						case TRIP_TYPE_ONE_WAY_CODE:
							this.routeType = 'editSidebar.label.oneWay';
							break;
						case TRIP_TYPE_MULTICITY_CODE:
							this.routeType = 'editSidebar.label.multicity';
							break;
						default:
							this.routeType = '';
							break;
					}
				}
			});

		this.stopover$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					this.stopover = value;
					
					this.hasStopover = true;
					if (this.isStopoverAvailabilityPage) {
						this.INDRA_mapHaulTypes();
					}
				}
			});

		this.passengers$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					this.passengers = value;
				}
			});

		this.bookingSteps$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					this.bookingSteps = value;
					value.forEach(item => {
						if (item.date)
							this.dates.push(item.date);
					});
				}
			});

		this.possitiveCallback$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					this.possitiveCallback = value;
				}
			});
	}

	ngOnInit() {
	}

	INDRA_getTextTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}

	INDRA_newSearch() {
		this.store.dispatch(new ConfirmModalActions.PutTitle(this.INDRA_getTextTranslation('editSidebar.text.newSearch')));
		this.store.dispatch(new ConfirmModalActions.PutBodyMsg(this.INDRA_getTextTranslation('editSidebar.label.wantToContinue')));
		this.store.dispatch(new ConfirmModalActions.PutOkLabel(this.INDRA_getTextTranslation('editSidebar.label.gotoNewSearch')));
		this.modalService.assignComponent(INDRAConfirmModalComponent);
		this.modalService.open();
		this.modalService.isOpen
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (!value) {
					if (this.possitiveCallback === 'ok') {
						//this.store.dispatch(new MiniIBEActions.Reset());
						this.sidebarService.closeSidebar();
						this.router.navigate(['booking']).then(() =>
            				this.router.navigate(['.', { outlets: { sidebar: null } }], { replaceUrl: true }));
						this.dates = [];
						
						/* note: from post sprint 8 merge
						if (this.isCorporate)
							this.router.navigate(['/corporate']);
						else
							this.router.navigate(['/']);
						*/
					}
				}
			});
	}

	/**
	 * Clear selected dates
	 */
	INDRA_clearDates() {
		const auxArray: Array<BookingStep> = [];
		this.bookingSteps.forEach(step => {
			auxArray.push(
				Object.assign(new BookingStep(null, null), step, {
					cost: null,
					date: null,
					date_selected: false
				})
			);
		});
		this.store.dispatch(new BookingStepsActions.PutStepsAction(auxArray));
		this.store.dispatch(new BookingStepsActions.PutCurrentStepAction(0));
	}

	INDRA_printPassengersDetail() {
		let detail = '';
		if (this.passengers) {
			detail += `<li class="passengers-list__item"><span class="bold">${this.passengers.adults}</span> ${this.INDRA_getTextTranslation('editSidebar.label.adult')}${this.passengers.adults === 1 ? '' : 's'}</li>`;
			detail += `<li class="passengers-list__item"><span class="bold">${this.passengers.youngAdults}</span> ${this.INDRA_getTextTranslation('editSidebar.label.youngAdult')}${this.passengers.youngAdults === 1 ? '' : 's'}</li>`;
			detail += `<li class="passengers-list__item"><span class="bold">${this.passengers.children}</span> ${this.passengers.children === 1 ? this.INDRA_getTextTranslation('editSidebar.label.child') : this.INDRA_getTextTranslation('editSidebar.label.children')}</li>`;
			detail += `<li class="passengers-list__item"><span class="bold">${this.passengers.infants}</span> ${this.INDRA_getTextTranslation('editSidebar.label.infant')}${this.passengers.children === 1 ? '' : 's'}</li>`;
		}
		return detail;
	}

	INDRA_printDateLabel(index) {
		return this.INDRA_getTextTranslation('editSidebar.label.to') + this.bookingSteps[index].arrival.location.city;
	}

	INDRA_printStopover(): string {
		let msg = '';
		this.stopover.map(item => {
			msg += '<li>' + item.days + this.INDRA_getTextTranslation('editSidebar.label.nightsStopoverIn') + item.city['location'].city + ' - ' + item.city['location'].country + '</li>';
		});
		return msg;
	}

	INDRA_editPassengers() {
		this.sidebarService.openSidebar(['edit-passengers']);
	}

	/** Handles close action intention **/
	INDRA_handleClose() {
		this.htmlElement[0].classList.remove('no-scroll');
		scrollLock.show();
		this.sidebarService.closeSidebar();
	}

	ngOnDestroy() {
		this.isAlive = false;
	}
	
	/**
	 *	check previous step item if stopover and is long haul
	 *	if has previous item and is stopover and long haul: display additional date (+1)
	 */
	INDRA_printDate(index, step) {
		let additionalDate = '';
		if (this.isStopoverAvailabilityPage && index !== 0 && this.bookingSteps[index-1].stopover && 
			this.INDRA_isLongHaulRoute(this.bookingSteps[index-1])) {
			additionalDate = this.dateService.INDRA_add(step.date, 1, 'days').format('DD MMM YYYY');
		}
		
		return ((additionalDate) ? (moment(step.date).format('DD MMM YYYY') + ' / ' + additionalDate) : 
			(moment(step.date).format('DD MMM YYYY')));
	}
	
	INDRA_isLongHaulRoute(step) {
		return (this.haulTypePerRoute.filter(route => 
			route.route == step.departure.code + '-' + step.arrival.code && route.haulType === FLIGHT_HAUL_TYPE_LONG).length > 0);
	}
	
	INDRA_mapHaulTypes() {	
		const availability = this.bfmDataStorage.INDRA_getBookingAvailability();
		if (availability && availability.data && availability.data.availabilityCombination && 
			availability.data.availabilityCombination.data && availability.data.availabilityCombination.data[0] &&
			availability.data.availabilityCombination.data[0].listOutbound && 
			availability.data.availabilityCombination.data[0].listOutbound.length > 0) {
			
			availability.data.availabilityCombination.data[0].listOutbound.forEach(outbound => {
				const routeHaulType = {
					route: outbound.listSegment[0].departureAirport + '-' + outbound.listSegment[outbound.listSegment.length-1].arrivalAirport,
					haulType: outbound.listSegment[outbound.listSegment.length-1].haul // what matters is the last segment haul type
				};
				this.haulTypePerRoute.push(routeHaulType);
			});
		}
	}
}




// import { Component, OnInit, OnDestroy } from '@angular/core';
// import { Store } from '@ngrx/store';
// import { Observable, Subscription } from 'rxjs';
// import { ActivatedRoute, NavigationEnd, ResolveEnd, Router } from '@angular/router';
// import { takeWhile } from 'rxjs/operators';

// import * as fromStore from '@ibe/store/index';
// import * as MiniIBEActions from '@ibe/store/actions/mini-ibe.actions';
// import * as ConfirmModalActions from '@ibe/store/actions/confirm-modal.actions';

// import { SidebarService } from '@ibe.components/common/sidebar/sidebar.service';
// import { PassengersSegmentedCount } from '@ibe/models';
// import { BookingStep } from '@ibe/models/ui';
// import { INDRAConfirmModalComponent } from '@ibe.components/shared/confirm-modal/confirm-modal.indra.component';
// import { ModalService } from '@ibe/services/ui';
// import { RouteTrip, Stopover } from '@ibe/store/states/mini-ibe.indra.state';
// import * as BookingStepsActions from '@ibe/store/actions/booking-steps.actions';
// import { TRIP_TYPE_ROUND_TRIP_CODE, TRIP_TYPE_ONE_WAY_CODE, TRIP_TYPE_MULTICITY_CODE, FLIGHT_HAUL_TYPE_LONG, COUNTRY_CODE_USA, COUNTRY_CODE_CANADA, SESSION_VAR_KEY_LANGUAGE, PAX_TYPE_ADULT, PAX_TYPE_YOUNG_ADULT, PAX_TYPE_CHILD, PAX_TYPE_INFANT, TRIP_TYPE_MULTICITY, SESSION_VAR_KEY_PASSENGERS, DISCOUNT_TYPE_PROMOCODE, TRIP_TYPE_ROUND_TRIP, TRIP_TYPE_ONE_WAY, DEFAULT_TRIP_TYPE, SESSION_VAR_KEY_MARKET, DEFAULT_MARKET, DEFAULT_AIRLINE_IDS, DISCOUNT_STATUS_ACTIVE, DISCOUNT_TYPE_VOUCHER, DISCOUNT_STATUS_INACTIVE, SESSION_VAR_KEY_SEARCH_ROUTE, SESSION_VAR_KEY_CURRENCY } from '@ibe.config';
// import scrollLock from 'scroll-lock';

// import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
// import { INDRADateService } from '@ibe.services/date.indra.service';
// import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
// import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

// import { BookedTrip, BookingType } from '@ibe.models/booked-trip.model.lib';
// import * as Moment from 'moment';
// import { BookingStepsEffect } from 'src/app/effects';
// import { INDRASelectAirportModalComponent } from '@ibe.components/shared/select-airport-modal/select-airport-modal.indra.component';
// import { INDRADatepickerModalComponent } from '@ibe.components/shared/datepicker-modal/datepicker-modal.indra.component';
// import { INDRASelectPassengersModalComponent } from '@ibe.components/shared/select-passengers-modal/select-passengers-modal.indra.component';
// import { BookingStepCost } from '@ibe.components/booking/steps/booking-steps/bookingStep';
// import { extendMoment } from 'moment-range';
// import { IMyDpOptions } from 'mydatepicker';
// import { BsLocaleService } from 'ngx-bootstrap/datepicker';
// import { INDRALanguageMarketService } from '@ibe.services/language-market-indra.service';
// import { listLocales } from 'ngx-bootstrap/chronos';
// import { INDRAAirport, INDRABFMJourneyDestinationResponse, INDRABFMJourneyOriginResponse, INDRADestinationDataRecon, INDRADestinations, INDRAJourneyParam, INDRAOriginDataRecon, INDRAOrigins } from '@ibe.models/airport.indra.model.lib';
// import * as FlightsFilterActions from '@ibe/store/actions/flights-filter.actions';
// import { INDRAParallelService } from '@ibe.services/parallel.indra.service';
// import { INDRAAirportLocationService } from '@ibe.services/airport-location.indra.service';
// import * as _ from 'lodash';
// import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
// import * as PromoVouchersActions from '@ibe/store/actions/promo-vouchers.actions';
// import { INDRADiscountService } from '@ibe.services/discount.indra.service';
// import { TimeoutSvcService } from '@ibe.services/timeout-svc.service';
// import { EVENT_ACTION_CLICK, INDRAGoogleAnalyticsService } from '@ibe.services/google.analytics.indra.service';

// const moment = extendMoment(Moment);
// const sinceDays = 366;

// @Component({
// 	selector: 'app-edit-search',
// 	templateUrl: './edit-search.indra.component.html',
// 	styleUrls: ['./edit-search.component.scss']
// })
// export class EditSearchComponent implements OnInit, OnDestroy {
// 	htmlElement = document.getElementsByTagName('html');
// 	isAlive = true;

// 	routeType$: Observable<string> = this.store.select(fromStore.getMiniIBERouteType);
// 	routeType: string;
	
// 	searchRoutes$: Observable<Array<any>> = this.store.select(fromStore.getMiniIBESearchRoutes);
// 	searchRoutes: Array<any>;

// 	bookedTripDiscounts$: Observable<Array<any>> = this.store.select(fromStore.getSelectedBookedTripDiscounts);
// 	bookedTripDiscounts: Array<any> = [];
	
// 	stopover$: Observable<Array<Stopover>> = this.store.select(fromStore.getMiniIBEStopovers);
// 	stopover: Array<Stopover>;
// 	hasStopover: boolean = false;

// 	passengers$ = this.store.select(fromStore.getMiniIBEPassengers);
// 	countPerPassenger;
	
// 	bookingSteps$: Observable<Array<BookingStep>> = this.store.select(fromStore.getSelectedBookingSteps);
// 	bookingSteps: Array<BookingStep> = [];

// 	bookedTrip$: Observable<BookedTrip> = this.store.select(fromStore.getSelectedBookedTrip);
// 	booked_trip: BookedTrip;

// 	possitiveCallback$: Observable<string> = this.store.select(fromStore.getConfirmModalConfirm);
// 	possitiveCallback = '';
	
// 	// isCorporate$: Observable<boolean> = this.store.select(fromStore.getIsCorporate);
// 	// isCorporate: boolean;
// 	dates = [];
// 	haulTypePerRoute = [];
// 	stepWithStopover;
// 	isStopoverAvailabilityPage: boolean = false;

// 	activeInput: string;
// 	type: 'flights' | 'stopover' | 'corporate' = 'flights';

// 	form: FormGroup;
	
// 	flightsFormControl = [];


// 	selectedRangeDates$: Observable<Array<Date>> = this.store.select(fromStore.getMiniIBERangeDates);
// 	selectedRangeDates;

// 	showAllOptions: boolean = false;
// 	triedToSubmit: boolean = false;
// 	hideAddFlight: boolean = false;

// 	bsRangeValue: Date[] = [];
// 	bsValue: any;
// 	minDate: Date;
// 	maxDate: Date;

// 	loadingPassengers = false;

// 	locale = 'pt-br';
// 	locales = listLocales();
	
// 	// Starting values for the form
// 	model = {
// 		from: null,
// 		to: null,
// 		routeType: null,
// 		flightType: this.type,
// 		payMethod: 'cash',
// 		bookAwardFlights: false,
// 		passengers: {
// 			[PAX_TYPE_ADULT]: 1,
// 			[PAX_TYPE_YOUNG_ADULT]: 0,
// 			[PAX_TYPE_CHILD]: 0,
// 			[PAX_TYPE_INFANT]: 0
// 		}
// 	};

// 	datepickerOptions: IMyDpOptions = {
// 		showClearDateBtn: false,
// 		disableUntil: {
// 			year: moment().year(),
// 			month: moment().month() + 1,
// 			day: parseFloat(moment().format('D')),
// 		},
// 		disableSince: {
// 			year: parseFloat(moment().add(sinceDays, 'days').format('YYYY')),
// 			month: parseFloat(moment().add(sinceDays, 'days').format('M')),
// 			day: parseFloat(moment().add(sinceDays, 'days').format('D')),
// 		},
// 		disableDateRanges: [],
// 		markCurrentDay: true,
// 		yearSelector: false,
// 		dateFormat: 'dd/mm/yyyy',
// 		showSelectorArrow: false,
// 		openSelectorOnInputClick: false,
// 		editableDateField: false,
// 		componentDisabled: true,
// 		allowSelectionOnlyInCurrentMonth: false,
// 		satHighlight: true,
// 		sunHighlight: true,
// 		showTodayBtn: false,
// 		inline: false,
// 		ariaLabelInputField: 'Text input for flight\'s new date',
// 		dayLabels: {
// 			su: 'S',
// 			mo: 'M',
// 			tu: 'T',
// 			we: 'W',
// 			th: 'T',
// 			fr: 'F',
// 			sa: 'S',
// 		},
// 	};
// 	language: any;
// 	allSubscription: Subscription[] = [];

// 	multicityRoutesPersistScenario = false;
// 	multicityOrigins: INDRAAirport[][] = [[], []];
// 	defaultMulticityOrigins = [null, null];
// 	multicityDestinations: INDRAAirport[][] = [[], []];
// 	defaultMulticityDestinations = [null, null];
// 	isMulticityOriginLoading: boolean[] = [false, false];
// 	isMulticityDestinationLoading: boolean[] = [false, false];
// 	destinations: INDRAAirport[];
// 	defaultDestination: string = null;
// 	isDestinationLoading = false;

// 	journeyRequestParam: INDRAJourneyParam = {
// 		market: null,
// 		language: null,
// 		airlineIds: null,
// 		payWithMiles: false
// 	};

// 	isPayWithMilesRoute = false;
// 	isPayWithMilesDisabled = false;
// 	prevIsPayWithMilesDisabled = false;
// 	originSubscription: Subscription;
// 	destinationSubscription: Subscription;
// 	multicityOriginSubscription: Subscription;
	
// 	private resetValuesCompleted$: Observable<boolean> = this.parallelService.resetValuesCompleted$;
// 	market$: Observable<any> = this.store.select(fromStore.getUserMarket);
// 	marketChange: boolean = false;
// 	seachRoute$: Observable<Array<RouteTrip>> = this.store.select(fromStore.getMiniIBESearchRoutes);
// 	seachRoute: Array<RouteTrip> = [];
// 	bookAwardFlights$: Observable<boolean> = this.store.select(fromStore.getFlightsFilterBookAwardFlights);
// 	bookAwardFlights; boolean = false;
// 	promocodesAndVouchers$: Observable<Array<any>> = this.store.select(fromStore.getSelectedPromoVouchers);
// 	promocodesAndVouchers: Array<any> = [];
// 	InitialOriginMulticityValue: any;
// 	InitialOriginValue: any;
// 	origins: INDRAAirport[];
// 	defaultOrigin: string = null;
// 	isOriginLoading = true;

// 	storedStopOver;
// 	loadStopover;
// 	routeTypeWithStopover;
// 	storedArrivalDate;
// 	storedDepartureDate;
// 	storedOWDepartureDate;

// 	incompletePreviousRow: boolean = false;
// 	invalidRowIndex: number = 0;
// 	loading: boolean;

// 	constructor(
// 		private router: Router,
// 		private route: ActivatedRoute,
// 		private store: Store<fromStore.State>,
// 		protected sidebarService: SidebarService,
// 		private modalService: ModalService,
// 		private bfmDataStorage: INDRABFMDataStorageService,
// 		private bookingStepsEffects: BookingStepsEffect,
// 		private dateService: INDRADateService,
// 		private ibeAdminService: INDRAIbeAdminService,
// 		private localeService: BsLocaleService,
// 		private fb: FormBuilder,
// 		private languageMarketService: INDRALanguageMarketService,
// 		private parallelService: INDRAParallelService,
// 		private airportService: INDRAAirportLocationService,
// 		protected bookingSearchService: INDRABookingSearchService,
// 		private discountService: INDRADiscountService,
// 		private timeoutSvc: TimeoutSvcService,
// 		private googleAnalytics: INDRAGoogleAnalyticsService,
// 	) {
// 		this.createForm();

// 		this.minDate = new Date();

// 		this.maxDate = new Date();
// 		this.maxDate.setDate(this.maxDate.getDate() + sinceDays);

// 		if (this.router.url.includes('/flights-stopover')) {
// 			this.isStopoverAvailabilityPage = true;
// 		}
		
// 		/* note: from post sprint 8 merge
// 		this.isCorporate$
// 			.pipe(takeWhile(() => this.isAlive))
// 			.subscribe(
// 				value => {
// 					this.isCorporate = value;
// 				}
// 			);
// 		*/

// 		this.routeType$
// 		.pipe(takeWhile(() => this.isAlive))
// 		.subscribe(value => {
// 			if (value) {
// 				switch (value) {
// 					case TRIP_TYPE_ROUND_TRIP_CODE:
// 						this.routeType = TRIP_TYPE_ROUND_TRIP_CODE;
// 						break;
// 					case TRIP_TYPE_ONE_WAY_CODE:
// 						this.routeType = TRIP_TYPE_ONE_WAY_CODE;
// 						break;
// 					case TRIP_TYPE_MULTICITY_CODE:
// 						this.routeType = TRIP_TYPE_MULTICITY_CODE;
// 						break;
// 					default:
// 						this.routeType = '';
// 						break;
// 				}
// 				this.form.get('routeType').setValue(value);
// 			}
// 		});

// 		this.searchRoutes$
// 		.pipe(takeWhile(() => this.isAlive))
// 		.subscribe(
// 			value => {
// 				if (value) {
// 					this.searchRoutes = value;
// 					if (this.routeType && this.routeType === TRIP_TYPE_MULTICITY_CODE) {
// 						this.processRoutes(value);
// 					}
// 				}
// 			}
// 		);

// 		this.stopover$
// 		.pipe(takeWhile(() => this.isAlive))
// 		.subscribe(value => {
// 			if (value) {
// 				this.stopover = value;
				
// 				this.hasStopover = true;
// 				if (this.isStopoverAvailabilityPage) {
// 					this.INDRA_mapHaulTypes();
// 				}
// 			}
// 		});

// 		this.passengers$
// 		.pipe(takeWhile(() => this.isAlive))
// 		.subscribe(value => {
// 			if (value) {
// 				if (this.form) {
// 					this.form.controls['passengers'].setValue({
// 						adults: value.adults,
// 						youngAdults: value.youngAdults,
// 						children: value.children,
// 						infants: value.infants
// 					});
// 				}
// 			}
// 		});

// 		this.bookingSteps$
// 		.pipe(takeWhile(() => this.isAlive))
// 		.subscribe(value => {
// 			if (value) {
// 				this.bookingSteps = value;
// 				value.forEach(item => {
// 					if (item.date)
// 						this.dates.push(item.date);
// 				});
// 			}
// 		});

// 		this.possitiveCallback$
// 		.pipe(takeWhile(() => this.isAlive))
// 		.subscribe(value => {
// 			if (value) {
// 				this.possitiveCallback = value;
// 			}
// 		});
		
// 		this.bookedTripDiscounts$
// 		.pipe(takeWhile(() => this.isAlive))
// 		.subscribe((discounts) => {
// 			if (discounts) {
// 				this.bookedTripDiscounts = discounts;
// 			}
// 		});

// 		this.bookedTrip$
// 		.pipe(takeWhile(() => this.isAlive))
// 		.subscribe((trip) => {
// 			if (trip) {
// 				this.booked_trip = trip;
// 			}
// 		});

// 		this.promocodesAndVouchers$
// 		.pipe(takeWhile(() => this.isAlive))
// 		.subscribe(discounts => {
// 			this.promocodesAndVouchers =  discounts && discounts.length ? discounts : [];
// 		});

// 		this.bookAwardFlights$
// 		.pipe(takeWhile(() => this.isAlive))
// 		.subscribe(value => {
// 			this.bookAwardFlights = value;
// 			if (this.bookAwardFlights) {
// 				this.INDRA_removeAdditionalMulticityRoutes();
// 			}
// 			this.INDRA_toggleVoucherPromocodes(this.bookAwardFlights);
// 			// this.createForm();
// 			/* if (this.tripType == TRIP_TYPE_MULTICITY) {
// 				const indexForm = (this.form.controls['flights'] as FormArray).at(0);
// 				indexForm.get('from').setValue(this.InitialOriginMulticityValue);
// 			} else {
// 				this.form.get('from').setValue(this.InitialOriginValue);
// 			} */
// 		});

// 		// this.router.events
// 		// 	.pipe(takeWhile(() => this.isAlive))
// 		// 	.subscribe((ev: any) => {
// 		// 		if (ev instanceof NavigationEnd || ev instanceof ResolveEnd) {
					
// 		// 			if (this.router.url.indexOf('sidebar') > 0) {
// 		// 				this.sidebarService.closeSidebar();
// 		// 			}
// 		// 		}
// 		// });
// 	}

// 	ngOnInit() {
// 		this.language = this.INDRA_getLanguage();
// 		this.selectedRangeDates$
// 			.pipe(takeWhile(() => this.isAlive))
// 			.subscribe((value) => {
// 				if (value) {
// 					if (value.length > 1 ) {
// 						this.selectedRangeDates = value;
// 						this.bsRangeValue = value;
// 						this.form.get('dateRange').setValue(value);
// 					} else {
// 						if (value[0]) {
// 							this.bsValue = value[0];
// 							this.form.get('dateOne').setValue(this.bsValue);
// 						}
// 					}
// 				}
// 			});

// 	}

// 	INDRA_getTextTranslation(key: string): string {
// 		return this.ibeAdminService.getTranslationValue(key);
// 	}

// 	INDRA_newSearch() {
// 		this.triedToSubmit = true;
// 		if (this.form.valid) {
// 			//start session timer
// 			this.timeoutSvc.startTimer();
// 			this.INDRA_navigate();
// 		} else if (this.form.invalid) {
// 			const firstElementWithError = document.querySelector('.ng-invalid');
// 			if (firstElementWithError) {
// 				firstElementWithError.scrollIntoView({ behavior: 'smooth' });
// 			}
// 		}
// 	}

// 	/**
// 	 * Clear selected dates
// 	 */
// 	INDRA_clearDates() {
// 		const auxArray: Array<BookingStep> = [];
// 		this.bookingSteps.forEach(step => {
// 			auxArray.push(
// 				Object.assign(new BookingStep(null, null), step, {
// 					cost: null,
// 					date: null,
// 					date_selected: false
// 				})
// 			);
// 		});
// 		this.store.dispatch(new BookingStepsActions.PutStepsAction(auxArray));
// 		this.store.dispatch(new BookingStepsActions.PutCurrentStepAction(0));
// 	}

// 	INDRA_printDateLabel(index) {
// 		return this.INDRA_getTextTranslation('editSidebar.label.to') + this.bookingSteps[index].arrival.location.city;
// 	}

// 	INDRA_printStopover(): string {
// 		let msg = '';
// 		this.stopover.map(item => {
// 			msg += '<li>' + item.days + this.INDRA_getTextTranslation('editSidebar.label.nightsStopoverIn') + item.city['location'].city + ' - ' + item.city['location'].country + '</li>';
// 		});
// 		return msg;
// 	}

// 	INDRA_editPassengers() {
// 		this.sidebarService.openSidebar(['edit-passengers']);
// 	}

// 	/** Handles close action intention **/
// 	INDRA_handleClose() {
// 		this.htmlElement[0].classList.remove('no-scroll');
// 		scrollLock.show();
// 		this.sidebarService.closeSidebar();
// 	}

// 	ngOnDestroy() {
// 		this.isAlive = false;
// 		for (const sub of this.allSubscription) {
// 			if (sub) {
// 				sub.unsubscribe();
// 			}
// 		}
// 	}
	
// 	/**
// 	 *	check previous step item if stopover and is long haul
// 	 *	if has previous item and is stopover and long haul: display additional date (+1)
// 	 */
// 	INDRA_printDate(index, step) {
// 		let additionalDate = '';
// 		if (this.isStopoverAvailabilityPage && index !== 0 && this.bookingSteps[index-1].stopover && 
// 			this.INDRA_isLongHaulRoute(this.bookingSteps[index-1])) {
// 			additionalDate = this.dateService.INDRA_add(step.date, 1, 'days').format('DD MMM YYYY');
// 		}
		
// 		return ((additionalDate) ? (moment(step.date).format('DD MMM YYYY') + ' / ' + additionalDate) : 
// 			(moment(step.date).format('DD MMM YYYY')));
// 	}
	
// 	INDRA_isLongHaulRoute(step) {
// 		return (this.haulTypePerRoute.filter(route => 
// 			route.route == step.departure.code + '-' + step.arrival.code && route.haulType === FLIGHT_HAUL_TYPE_LONG).length > 0);
// 	}
	
// 	INDRA_mapHaulTypes() {	
// 		const availability = this.bfmDataStorage.INDRA_getBookingAvailability();
// 		if (availability && availability.data && availability.data.availabilityCombination && 
// 			availability.data.availabilityCombination.data && availability.data.availabilityCombination.data[0] &&
// 			availability.data.availabilityCombination.data[0].listOutbound && 
// 			availability.data.availabilityCombination.data[0].listOutbound.length > 0) {
			
// 			availability.data.availabilityCombination.data[0].listOutbound.forEach(outbound => {
// 				const routeHaulType = {
// 					route: outbound.listSegment[0].departureAirport + '-' + outbound.listSegment[outbound.listSegment.length-1].arrivalAirport,
// 					haulType: outbound.listSegment[outbound.listSegment.length-1].haul // what matters is the last segment haul type
// 				};
// 				this.haulTypePerRoute.push(routeHaulType);
// 			});
// 		}
// 	}

// 	/**
// 	 * Create form controls with initial values and restrictions
// 	 */
// 	private createForm() {
// 		this.form = this.fb.group({
// 			flights: this.fb.array([
// 				this.fb.group({
// 					from: [this.model.from, Validators.required],
// 					to: [this.model.to, Validators.required],
// 					date: [null, Validators.required]
// 				}),
// 				this.fb.group({
// 					from: [null, Validators.required],
// 					to: [null, Validators.required],
// 					date: [null, Validators.required]
// 				})
// 			]),
// 			stopovers: new FormArray([]),
// 			from: [this.model.from, Validators.required],
// 			to: [this.model.to, Validators.required],
// 			routeType: [this.model.routeType, Validators.required],
// 			flightType: [this.model.flightType, Validators.required],
// 			payMethod: [this.model.payMethod, Validators.required],
// 			bookAwardFlights: [this.model.bookAwardFlights, Validators.required],
// 			passengers: this.fb.group({
// 				[PAX_TYPE_ADULT]: [this.model.passengers[PAX_TYPE_ADULT], Validators.required],
// 				[PAX_TYPE_YOUNG_ADULT]: [this.model.passengers[PAX_TYPE_YOUNG_ADULT], Validators.required],
// 				[PAX_TYPE_CHILD]: [this.model.passengers[PAX_TYPE_CHILD], Validators.required],
// 				[PAX_TYPE_INFANT]: [this.model.passengers[PAX_TYPE_INFANT], Validators.required]
// 			}),
// 			dateRange: new FormControl(null),
// 			dateOne: new FormControl(null)
// 		});


// 		const TypeOfFlight = (AC: AbstractControl) => {
// 			const routeType = AC.get('routeType').value;
// 			const form = (AC as FormGroup);

// 			if (routeType == TRIP_TYPE_MULTICITY) {
// 				AC.get('from').setErrors(null);
// 				AC.get('from').clearValidators();

// 				AC.get('to').setErrors(null);
// 				AC.get('to').clearValidators();

// 				const checkDates = (form.controls['flights'] as FormArray).value.reduce((acc, cur, idx, src) => {

// 					if (!acc.error && cur.date) {
// 						const dt = moment(`${cur.date.date.year}-${cur.date.date.month}-${cur.date.date.day}`, 'YYYY-M-D');
// 						if (acc.lastdate && dt.isBefore(acc.lastdate)) {
// 							acc.error = true;
// 							acc.idx = idx;
// 						}
// 						acc.lastdate = dt.format('YYYY-MM-DD');
// 						return acc;
// 					}

// 					return acc;

// 				}, { error: false, lastdate: null, idx: null });

// 				if ((form.controls['flights'] as FormArray).length <= 1) {
// 					AC.get('flights').setErrors({ LengthFlights: true });
// 				} else {

// 					AC.get('flights').setErrors(null);
// 					AC.get('flights').clearValidators();

// 					if (checkDates.error) (AC.get('flights') as FormArray).at(checkDates.idx).setErrors({ DateFlights: true });
// 				}

// 				(form.controls['flights'] as FormArray).controls.map(cur => {
// 					cur.get('from').setValidators(Validators.required);
// 					cur.get('to').setValidators(Validators.required);
// 					cur.get('date').setValidators(Validators.required);
// 				});

// 			} else {
// 				AC.get('from').setValidators(Validators.required);
// 				AC.get('to').setValidators(Validators.required);

// 				(form.controls['flights'] as FormArray).controls.map(cur => {
// 					cur.get('from').setErrors(null);
// 					cur.get('from').clearValidators();

// 					cur.get('to').setErrors(null);
// 					cur.get('to').clearValidators();

// 					cur.get('date').setErrors(null);
// 					cur.get('date').clearValidators();
// 				});
// 			}
// 			return null;
// 		};

// 		this.form.setValidators(TypeOfFlight);
// 		// this.store.dispatch(new MiniIBEActions.PutPassengers(this.fb.group['passengers'])); // from Sprint 5 merge
// 	}

// 	// getter for passengers
// 	get passengers() {
// 		return this.form.get('passengers');
// 	}

// 	/***
// 	 *** 
// 	  **/

// 	 private processRoutes(routesTable) {
		
// 		if (routesTable) 
// 			this.searchRoutes = routesTable;

// 		if (this.routeType === TRIP_TYPE_MULTICITY_CODE) {
// 			this.searchRoutes.forEach((item, index)  => {
// 				const formItem = (this.form.controls['flights'] as FormArray).at(index);
// 				if (formItem) {
// 					formItem.get('from').setValue(item['departure']);
// 					formItem.get('to').setValue(item['arrival']);
// 					formItem.get('date').setValue(item['date'] ?
// 						{ date: {
// 							year: moment(item['date']).format('YYYY'),
// 							month: moment(item['date']).format('M'),
// 							day: moment(item['date']).format('D')
// 							}
// 						} : null);
// 				}
// 				else {
// 					(this.form.controls['flights'] as FormArray).push(
// 						this.fb.group({
// 							from: [item['departure'], Validators.required],
// 							to: [item['arrival'], Validators.required],
// 							date: [item['date'] ?
// 								{ date: {
// 									year: moment(item['date']).format('YYYY'),
// 									month: moment(item['date']).format('M'),
// 									day: moment(item['date']).format('D')
// 									}
// 								} : null, Validators.required]
// 						})
// 					);
// 				}		
// 			})
// 		} 
// 		else {
// 			const xRoutes = this.searchRoutes[0];
// 			if (xRoutes['departure']) {
// 			this.form.get('from').setValue(xRoutes['departure']);
// 			}
// 		  	if (xRoutes['arrival']) {
// 			  this.form.get('to').setValue(xRoutes['arrival']);
// 		  	}
// 			if (xRoutes['date']) {
// 				this.form.get('dateOne').setValue(xRoutes['date']);
// 			}
// 		}

// 	 }
	
// 	INDRA_setShowAllOptions(text: string = '', index = 0): void {

// 		this.store.dispatch(new MiniIBEActions.PutCurrentSearchRoute(index));
// 		this.store.dispatch(new MiniIBEActions.PutActiveInput(text));

// 		this.showAllOptions = true;
// 	}

// 	INDRA_getFlightsControl() {
// 		if (this.form.controls['flights'] !== undefined) {
// 			const flights = <FormArray>this.form.controls['flights'];
// 			if (flights.controls.length) {
// 				/*
// 				if (flights.controls.length == 6) {
// 					this.hideAddFlight = true;
// 				} else if (flights.controls.length < 6) {
// 					this.hideAddFlight = false;
// 				}
// 				*/
// 				return flights.controls;
// 			}
// 		}
// 	}

// 	INDRA_isMulticity() {
// 		return this.form.get('routeType').value === TRIP_TYPE_MULTICITY_CODE;
// 	}

// 	INDRA_isOneway() {
// 		return this.form.get('routeType').value === TRIP_TYPE_ONE_WAY_CODE;
// 	}

// 	INDRA_adjustmentDate(date) {
// 		const newDate = date && date.date ? date.date : date;
// 		return newDate
// 			? moment(
// 				`${newDate.year}-${newDate.month}-${newDate.day}`,
// 				'YYYY-M-D'
// 			).toDate()
// 			: null;
// 	}

// 	INDRA_cantChange(index: any) {
// 		if (index) {
// 			return !this.form.controls['flights'].value[index].from;
// 		} else {
// 			if (!this.form.controls['from'].value) this.form.controls['to'].reset();
// 			return !this.form.controls['from'].value;
// 		}
// 	}

// 	INDRA_openMobileDatepickerModal(index) {
// 		const flights = this.form.controls['flights'].value.map((cur) => ({
// 			departure: cur.from,
// 			arrival: cur.to,
// 			date: this.INDRA_adjustmentDate(cur.date),
// 		}));

// 		this.store.dispatch(new MiniIBEActions.PutActiveInput(null));
// 		this.store.dispatch(new MiniIBEActions.PutSearchRoute(flights));
// 		this.store.dispatch(new MiniIBEActions.PutCurrentSearchRoute(index));

// 		const disableDays = this.form.controls['flights'].value
// 			.filter((cur) => cur.date)
// 			.map((cur) => ({
// 				year: parseFloat(cur.date.date.year),
// 				month: parseFloat(cur.date.date.month),
// 				day: parseFloat(cur.date.date.day),
// 			}));

// 		let valueDefMonth = '';

// 		const currentFlights = flights[index];

// 		if (currentFlights.date) {
// 			valueDefMonth = currentFlights.date;
// 		} else {
// 			if (index > 0) {
// 				const pastFlights = flights[index - 1];

// 				if (pastFlights.date) {
// 					valueDefMonth = pastFlights.date;
// 				}
// 			}
// 		}

// 		this.modalService.assignComponent(INDRADatepickerModalComponent, {
// 			params: {
// 				datepickerOptions: {
// 					highlightDates: disableDays,
// 					disableUntil: this.disableUntil(flights, index),
// 					disableSince: this.disableSince(flights, index),
// 				},
// 				value: valueDefMonth,
// 			},
// 			handleClose: (event) => {
// 				if (event.date) {
// 					this.store.dispatch(new MiniIBEActions.PutActiveInput('date'));
// 					this.store.dispatch(
// 						new MiniIBEActions.PutSearchRoute(
// 							moment(
// 								`${event.date.year}-${event.date.month}-${event.date.day}`,
// 								'YYYY-M-D'
// 							).toDate()
// 						)
// 					);
// 				}
// 			},
// 		});
// 		this.modalService.open();
// 	}

// 	INDRA_openMobilePassengersModal() {
// 		this.modalService.assignComponent(INDRASelectPassengersModalComponent, {
// 			handleClose: (_, res) => {
// 				if (res) {
// 					this.store.dispatch(new MiniIBEActions.PutPassengers(res));
// 					this.form.controls['passengers'].setValue(res);
// 					// this.passengers.setValue(res, { onlySelf: true, emitEvent: false });
// 				}
// 			},
// 		});
// 		this.modalService.open();
// 	}

// 	private disableSince(flights, index) {
// 		let minDate;

// 		for (let i = index + 1; i < flights.length; i++) {
// 			if (minDate == undefined && flights[i].date) {
// 				minDate = flights[i].date;
// 			} else if (minDate && flights[i].date) {
// 				minDate = minDate > flights[i].date ? flights[i].date : minDate;
// 			}
// 		}

// 		if (minDate) {
// 			return this.createDatepickerObject(moment(minDate).add('days', 1));
// 		}

// 		return {};
// 	}

// 	private disableUntil(flights, index) {
// 		let maxDate;

// 		for (let i = index - 1; i > -1; i--) {
// 			if (maxDate == undefined && flights[i].date) {
// 				maxDate = flights[i].date;
// 			} else if (flights[i].date > maxDate) {
// 				maxDate = flights[i].date;
// 			}
// 		}

// 		if (maxDate) {
// 			return this.createDatepickerObject(moment(maxDate).subtract('days', 1));
// 		}

// 		return this.yesterday();
// 	}

// 	private yesterday() {
// 		return this.createDatepickerObject(moment().subtract('days', 1));
// 	}

// 	private createDatepickerObject(date) {
// 		if (!date) {
// 			return {};
// 		}

// 		const d = moment(date);
// 		return {
// 			year: parseFloat(d.format('YYYY')),
// 			month: parseFloat(d.format('M')),
// 			day: parseFloat(d.format('D')),
// 		};
// 	}

// 	setDatepickerLocale() {
// 		/* "ar", "en", "de", "en-gb", "es", "fr", "it", "nl", "pl", "pt-br", "ru", "zh-cn" */
// 		const market = sessionStorage.getItem('market');
		
// 		// corrections for the library-specific locale codes
// 		if (this.language === 'pt') {
// 			this.locale = 'pt-br';
// 		} else if (this.language === 'en' && market !== COUNTRY_CODE_USA && market !== COUNTRY_CODE_CANADA) {
// 			this.locale = 'en-gb';
// 		} else if (this.language=== 'en-us') {
// 			this.locale = 'en';
// 		} else if (this.language === 'zh') {
// 			this.locale = 'zh-cn';
// 		} else {
// 			this.locale = this.language ? this.language : 'pt-br';
// 		}
		
// 		this.localeService.use(this.locale);
// 	}

// 	/**
// 	 * Handle Autocomplete Selection
// 	 * @param event new value for the airport
// 	 * @param endpoint either 'to' or 'from'
// 	 */
// 	INDRA_selectEndpoint(event: any, endpoint: string, index = 0) {
// 		console.log('INDRA_selectEndpoint')
// 		this.multicityRoutesPersistScenario = false;
// 		const routeType = this.form.get('routeType').value;
// 		const formArraySize = (this.form.controls['flights'] as FormArray).length;

// 		// loads departure and arrival destinations when recent search is clicked.
// 		if (event && event.type == 'recent-search') {
// 			this.store.dispatch(new MiniIBEActions.PutPassengers(this.model.passengers));
// 			if (routeType === TRIP_TYPE_MULTICITY) {
// 				// NOTE: only first row of multicity is supported by recent search functionality..
// 				const iform = (this.form.controls['flights'] as FormArray).at(index);
// 				iform.get('from').setValue(event.value.departure);
// 				iform.get('to').setValue(event.value.arrival);

// 				this.INDRA_fetchDestinationForMulticity(0);
// 			} else {
// 				this.form.get('from').setValue(event.value.departure);
// 				this.form.get('to').setValue(event.value.arrival);
// 				this.INDRA_fetchDestinationForNonMulticity();
// 			}
// 		} else {
// 			// handles end points for other events
// 			this.store.dispatch(new MiniIBEActions.PutCurrentSearchRoute(index));
// 			this.store.dispatch(new MiniIBEActions.PutActiveInput(endpoint));
// 			this.store.dispatch(new MiniIBEActions.PutSearchRoute(event));
// 			sessionStorage.removeItem(SESSION_VAR_KEY_PASSENGERS);

// 			const newValue = {};
// 			newValue[endpoint] = event;

// 			const form = (this.form.controls['flights'] as FormArray).at(index);

// 			if (endpoint === 'from') {
// 				if (routeType === TRIP_TYPE_MULTICITY) {
// 					form.patchValue(newValue);
// 					if (event) {
// 						this.INDRA_fetchDestinationForMulticity(index);
// 					} else {
// 						// resets value for the destination field of the multicity index..
// 						for (let i = index; i <= formArraySize - 1; i++) {
// 							const iform = (this.form.controls['flights'] as FormArray).at(i);
// 							if (iform) {
// 								if (i > index) {
// 									this.multicityDestinations[index] = [];
// 									iform.get('from').setValue(null);
// 									this.store.dispatch(new MiniIBEActions.PutCurrentSearchRoute(i));
// 									this.store.dispatch(new MiniIBEActions.PutActiveInput(endpoint));
// 									this.store.dispatch(new MiniIBEActions.PutSearchRoute(null));
// 								}
// 								iform.get('to').setValue(null);
// 								this.store.dispatch(new MiniIBEActions.PutCurrentSearchRoute(i));
// 								this.store.dispatch(new MiniIBEActions.PutActiveInput('to'));
// 								this.store.dispatch(new MiniIBEActions.PutSearchRoute(null));
// 								this.store.dispatch(new FlightsFilterActions.PutFlightWithMiles(false));
// 							}
// 						}

// 						// brings back CurrentSearchRoute to the correct index after clearing succeeding indices/rows
// 						this.store.dispatch(new MiniIBEActions.PutCurrentSearchRoute(index));
// 					}
// 				} else {
// 					this.form.patchValue(newValue);
// 					if (event) {
// 						this.INDRA_fetchDestinationForNonMulticity();
// 					} else {
// 						// resets value for the destination field..
// 						this.destinations = [];
// 						this.form.get('to').setValue(null);
// 						this.store.dispatch(new MiniIBEActions.PutCurrentSearchRoute(index));
// 						this.store.dispatch(new MiniIBEActions.PutActiveInput('to'));
// 						this.store.dispatch(new MiniIBEActions.PutSearchRoute(null));
// 						this.store.dispatch(new FlightsFilterActions.PutFlightWithMiles(false));
// 					}
// 				}
// 			} else {
// 				if (routeType === TRIP_TYPE_MULTICITY) {
// 					if (event) {
// 						form.patchValue(newValue);
// 						// this will fetch the origin for the next row..
// 						this.INDRA_fetchOriginForMulticity(index + 1);
// 					} else {
// 						// resets origin and destinations fields of succeeding M rows..
// 						for (let i = index + 1; i <= formArraySize - 1; i++) {
// 							const nextform = (this.form.controls['flights'] as FormArray).at(i);
// 							if (nextform) {
// 								this.multicityDestinations[i] = [];
// 								this.multicityOrigins[i] = [];
// 								nextform.get('from').setValue(null);
// 								nextform.get('to').setValue(null);
// 								this.store.dispatch(new MiniIBEActions.PutCurrentSearchRoute(i));
// 								this.store.dispatch(new MiniIBEActions.PutActiveInput('from'));
// 								this.store.dispatch(new MiniIBEActions.PutSearchRoute(null));
// 								this.store.dispatch(new MiniIBEActions.PutActiveInput('to'));
// 								this.store.dispatch(new MiniIBEActions.PutSearchRoute(null));
// 							}
// 						}

// 						// brings back CurrentSearchRoute to the correct index after clearing succeeding indices/rows
// 						this.store.dispatch(new MiniIBEActions.PutCurrentSearchRoute(index));
// 					}
// 				} else {
// 					this.form.patchValue(newValue);
// 				}
// 			}
// 		}
// 		if (this.INDRA_checkSelectFlights()) this.showAllOptions = true;

// 		// this.store.dispatch(new MiniIBEActions.PutCurrentSearchRoute(index));
// 		// this.store.dispatch(new MiniIBEActions.PutActiveInput(endpoint));

// 		// const newValue = {};
// 		// newValue[endpoint] = event;
// 		// this.form.patchValue(newValue);
		
// 		// this.store.dispatch(new MiniIBEActions.PutSearchRoute(event));

// 		// if (this.INDRA_checkSelectFlights()) this.showAllOptions = true;
// 		// if (endpoint === 'from')
// 		// 	if (event)
// 		// 		if (this.INDRA_isMulticity()) {
// 		// 			if (this.activeInput !== 'to') {
// 		// 				document.getElementById('flight-search-to-' + index).focus();
// 		// 				this.activeInput = 'to';
// 		// 			}
// 		// 		} else {
// 		// 			if (this.activeInput !== 'to') {
// 		// 				document.getElementById('flight-search-to').focus();
// 		// 				this.activeInput = 'to';
// 		// 			}
// 		// 		}
// 		// 	else {
// 		// 		if (this.INDRA_isMulticity()) {
// 		// 			const controls = this.form.controls['flights'] as FormArray;
// 		// 			controls.controls[index].get('to').setValue(null);
// 		// 		} else {
// 		// 			this.form.controls['to'].setValue(null);
// 		// 		}
// 		// 	}

// 	}

// 	INDRA_selectTripType(value) {
// 		let label = '';
// 		if (value == TRIP_TYPE_ONE_WAY_CODE) label = TRIP_TYPE_ONE_WAY_CODE;
// 		if (value == TRIP_TYPE_ROUND_TRIP_CODE) label = TRIP_TYPE_ROUND_TRIP_CODE;
// 		if (value == TRIP_TYPE_MULTICITY_CODE) label = TRIP_TYPE_MULTICITY_CODE;

// 		this.form.get('routeType').setValue(label);

// 		this.store.dispatch(new MiniIBEActions.PutRouteType(label));
// 		this.store.dispatch(new MiniIBEActions.PutCurrentSearchRoute(0));
// 		this.store.dispatch(new MiniIBEActions.PutActiveInput(''));
// 	}

// 	INDRA_checkSelectFlights() {
// 		return this.form.value.flights.filter((cur) => cur.from && cur.to).length;
// 	}

// 	INDRA_addMoreFlight() {
// 		(this.form.controls['flights'] as FormArray).push(
// 			this.fb.group({
// 				from: [null, Validators.required],
// 				to: [null, Validators.required],
// 				date: [null, Validators.required],
// 			})
// 		);

// 		if (this.INDRA_getFlightsControl().length > 2) {
// 			this.store.dispatch(new MiniIBEActions.PutStovers([]));
// 		}

// 		const searchRoute = Object.assign([], this.searchRoutes);
// 		searchRoute.push({ departure: null, arrival: null, date: null });

// 		this.store.dispatch(new MiniIBEActions.PutActiveInput(null));
// 		this.store.dispatch(new MiniIBEActions.PutSearchRoute(searchRoute));
// 	}

// 	INDRA_openMobileAirportModal(text, index = 0) {
// 		if (this.INDRA_checkSelectFlights()) this.showAllOptions = true;
// 		this.store.dispatch(new MiniIBEActions.PutActiveInput(text));
// 		this.store.dispatch(new MiniIBEActions.PutCurrentSearchRoute(index));
// 		this.modalService.assignComponent(INDRASelectAirportModalComponent, {
// 			handleClose: (event) => {
// 				if (event) {
// 					this.showAllOptions = true;
// 				}
// 			},
// 		});
// 		this.modalService.open();
// 	}

// 	public onDateRangeChange(event: Array<Date>): void {
// 		this.selectedRangeDates = event;
// 		this.store.dispatch(new MiniIBEActions.PutRangeDates(event));
// 	}

// 	public onDateChange(event: Date, index): void {
// 		let dateArr = [];
// 		if (event) {
// 			dateArr.push(event);
// 		}
// 		this.store.dispatch(new MiniIBEActions.PutRangeDates(dateArr));
// 	}

// 	INDRA_onDateChanged(event: Date, index) {
		
// 		const dRef: Date[] = [event];
// 		this.store.dispatch(new MiniIBEActions.PutRangeDates(dRef));
// 		// ------------
// 		/*
// 		const flights = this.form.controls['flights'].value.map((cur) => ({
// 			departure: cur.from,
// 			arrival: cur.to,
// 			date: event,
// 		}));
	
// 		this.store.dispatch(new MiniIBEActions.PutActiveInput(null));
// 		this.store.dispatch(new MiniIBEActions.PutSearchRoute(flights));
// 		this.store.dispatch(new MiniIBEActions.PutCurrentSearchRoute(index));
// 		*/


// 	}

// 	INDRA_removeFlight(index) {
// 		(this.form.controls['flights'] as FormArray).removeAt(index);
// 		const flights = this.form.controls['flights'].value.map((cur) => ({
// 			departure: cur.from,
// 			arrival: cur.to,
// 			date: this.INDRA_adjustmentDate(cur.date),
// 		}));

// 		this.store.dispatch(new MiniIBEActions.PutActiveInput(null));
// 		this.store.dispatch(new MiniIBEActions.PutSearchRoute(flights));
// 	}

// 	INDRA_isActiveDatePicker(index) {
// 		return (this.form.controls['flights'] as FormArray).at(index).get('date').value;
// 	}

// 	INDRA_showError(control) {
// 		return this.triedToSubmit && !control.valid;
// 	}

// 	/**
//  * Populate book type radio group
//  */
// 	INDRA_updateBookTypeOptions(event) {
// 		console.log('INDRA_updateBookTypeOptions', event);
// 		let refId = TRIP_TYPE_ROUND_TRIP_CODE;
// 		if (this.routeType === TRIP_TYPE_ONE_WAY_CODE) 
// 			refId = TRIP_TYPE_ONE_WAY_CODE
// 		else if (this.routeType === TRIP_TYPE_MULTICITY_CODE) 
// 			refId = TRIP_TYPE_MULTICITY_CODE;

// 		return refId;
// 	}

// 	INDRA_getLanguage() {
// 		const defaultlangMarket = this.languageMarketService.loadDefaultLanguageMarket();
// 		let selectedLanguageCode;

// 		if (sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE)) {
// 			selectedLanguageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE);
// 		} else {
// 			selectedLanguageCode = defaultlangMarket[0];
// 		}

// 		return selectedLanguageCode;
// 	}

// 	INDRA_fetchOriginForMulticity(index: number = 0) {
// 		this.isMulticityOriginLoading[index] = true;
// 		const param = _.clone(this.journeyRequestParam);
// 		param.tripType = TRIP_TYPE_MULTICITY;
// 		param.payWithMiles = this.isPayWithMilesRoute;
// 		// resets dataOptions from row of the index and succeeding flights..
// 		const formArraySize = (this.form.controls['flights'] as FormArray).length;
// 		for (let i = index; i <= formArraySize - 1; i++) {
// 			if (i > index) {
// 				this.multicityOrigins[i] = [];
// 			}
// 			this.multicityDestinations[i] = [];
// 		}
// 		delete param['origin'];
// 		if (index == 0) {
// 			this.resetValuesCompleted$.subscribe((completed) => {
// 				if (completed) {
// 					this.multicityOriginSubscription =
// 					this.airportService.IndraGetOrigins(param).subscribe((response: INDRABFMJourneyOriginResponse) => {
// 						if (response && response.data && response.status === '200') {
// 								// this instantiation involves massaging of data to meet the data structure
// 							// expected on the airport input component
// 							const originDataRecon = new INDRAOriginDataRecon(response);
// 							const data: INDRAOrigins = originDataRecon.data;
// 							if (data.origins && data.origins.length > 0) {
// 								this.multicityOrigins[index] = data.origins;
// 								this.defaultMulticityOrigins[index] = data.default;
// 								this.INDRA_setInitialAirportValue('from', index, data.origins);
// 							}
// 						}
// 						this.isMulticityOriginLoading[index] = false;
// 					}, error => {
// 						this.isMulticityOriginLoading[index] = false;
// 					});
// 				}
// 			});
// 		} else {
// 			const form = (this.form.controls['flights'] as FormArray).at(index - 1);
// 			param.previousDestination = form.get('to').value.code;
// 			delete param['tripType'];
// 			this.multicityOriginSubscription =
// 				this.airportService.INDRAGetMulticityOrigins(param).subscribe(
// 					(response: INDRABFMJourneyOriginResponse) => {
// 					if (response && response.data && response.status === '200') {
// 						// this instantiation involves massaging of data to meet the data structure
// 						// expected on the airport input component
// 						const mapDefaultAirport = false; // for second row onwards, there should not be a default airport
// 						const originDataRecon = new INDRAOriginDataRecon(response, mapDefaultAirport);
// 						const data: INDRAOrigins = originDataRecon.data;
// 						if (data.origins && data.origins.length > 0) {
// 							this.multicityOrigins[index] = data.origins;
// 							this.defaultMulticityOrigins[index] = data.default;
// 							this.INDRA_setInitialAirportValue('from', index, data.origins);
// 						}
// 					}
// 					this.isMulticityOriginLoading[index] = false;
// 				}, error => {
// 					this.isMulticityOriginLoading[index] = false;
// 				});
// 		}

// 		if (this.multicityOriginSubscription) {
// 			this.allSubscription.push(this.multicityOriginSubscription);
// 		}
// 	}

// 	INDRA_setInitialAirportValue(endpoint: string, index: number = 0, origins?) {
// 		let defaultAirportForEndpoint = null;
// 		const indexForm = (this.form.controls['flights'] as FormArray).at(index);
// 		if (endpoint === 'from') {
// 			// setting of initial value for origin field..
// 			if (this.form.get('routeType').value === TRIP_TYPE_MULTICITY) {
// 				// if same market, always retain origin when switching tab. when changing market, only retain if origin and dest are both supplied.
// 				const retain = !this.marketChange || (this.marketChange && ((this.seachRoute[index] && this.seachRoute[index].arrival) || index !== 0)) ? true : false;
// 				if (this.seachRoute[index] && this.seachRoute[index].departure && retain) {

// 					// If there's any selected input from previous steps, it will be copied on the rows of M trip..
// 					let multicityFromValue = this.INDRA_getAirportByCode(
// 						this.seachRoute[index].departure.code, origins);

// 					// if multicityFromValue is NULL/undefined, it means that the current departure in search route is invalid
// 					// thus we need to set the current default origin as the multicityFromValue and dispatch it to the searchroute
// 					if (!multicityFromValue) {
// 						this.InitialOriginMulticityValue = this.INDRA_getAirportByCode(
// 							this.defaultMulticityOrigins[index], this.multicityOrigins[index]);
// 						multicityFromValue = this.InitialOriginMulticityValue;
// 						this.store.dispatch(new MiniIBEActions.PutCurrentSearchRoute(index));
// 						this.store.dispatch(new MiniIBEActions.PutActiveInput(endpoint));
// 						this.store.dispatch(new MiniIBEActions.PutSearchRoute(multicityFromValue));
// 					}

// 					this.InitialOriginMulticityValue = multicityFromValue;
// 					if (indexForm) {
// 						if (index > 0) {
// 							const eligibleForAwardRoute =
// 								this.bookingSearchService.INDRA_getAirportAwardBookingEligibility(multicityFromValue);
// 							const eligibleForCommercialRoute =
// 								this.bookingSearchService.INDRA_getAirportCommercialBookingEligbility(multicityFromValue);

// 							// Only set the origin to form IF it is eligible for the type of booking.
// 							// if pay with miles = true, it should be eligible for award booking;
// 							// if pay with miles = false, it should be eligible for commercial booking;
// 							// Note: This check is needed since we are calling origin and destination list
// 							//       everytime we check/uncheck pay with miles checkbox.
// 							if ((!eligibleForAwardRoute && this.bookAwardFlights) ||
// 								(!eligibleForCommercialRoute && !this.bookAwardFlights)) {
// 								// since not eligible, reset the search route
// 								this.form.get(endpoint).setValue(null);
// 								this.store.dispatch(new MiniIBEActions.PutCurrentSearchRoute(index));
// 								this.store.dispatch(new MiniIBEActions.PutActiveInput(endpoint));
// 								this.store.dispatch(new MiniIBEActions.PutSearchRoute(null));
// 							} else {
// 								this.form.get(endpoint).setValue(multicityFromValue);
// 								this.store.dispatch(new MiniIBEActions.PutCurrentSearchRoute(index));
// 								this.store.dispatch(new MiniIBEActions.PutActiveInput(endpoint));
// 								this.store.dispatch(new MiniIBEActions.PutSearchRoute(multicityFromValue));
// 								this.INDRA_fetchDestinationForMulticity(index);
// 							}
// 						} else {
// 							indexForm.get(endpoint).setValue(multicityFromValue);

// 							this.store.dispatch(new MiniIBEActions.PutCurrentSearchRoute(index));
// 							this.store.dispatch(new MiniIBEActions.PutActiveInput(endpoint));
// 							this.store.dispatch(new MiniIBEActions.PutSearchRoute(multicityFromValue));
							
// 							this.INDRA_fetchDestinationForMulticity(index);
// 						}
// 					}
// 				} else {
// 					// otherwise, default origin from API will be set..
// 					defaultAirportForEndpoint = this.INDRA_getAirportByCode(
// 						this.defaultMulticityOrigins[index], this.multicityOrigins[index]);

// 					this.InitialOriginMulticityValue = defaultAirportForEndpoint == undefined ?
// 						this.InitialOriginMulticityValue : defaultAirportForEndpoint;

// 					if (indexForm) {
// 						 indexForm.get(endpoint).setValue(defaultAirportForEndpoint);
// 						this.store.dispatch(new MiniIBEActions.PutCurrentSearchRoute(index));
// 						this.store.dispatch(new MiniIBEActions.PutActiveInput(endpoint));
// 						this.store.dispatch(new MiniIBEActions.PutSearchRoute(defaultAirportForEndpoint));
// 					}
// 					if (defaultAirportForEndpoint) {
// 						this.INDRA_fetchDestinationForMulticity(index);
// 					}
// 				}
// 			} else {
// 				// for RT/OW
// 				// if same market, always retain origin when switching tab. when changing market, only retain if origin and dest are both supplied.
// 				const retain = !this.marketChange || (this.marketChange && (this.seachRoute[index] && this.seachRoute[index].arrival)) ? true : false;
// 				if (this.seachRoute[index] && this.seachRoute[index].departure && retain) {
// 					// If there's any selected input from previous steps, it will be copied RT/OW origin..
// 					let fromValue = this.INDRA_getAirportByCode(this.seachRoute[index].departure.code, this.origins);

// 					// if fromValue is NULL/undefined, it means that the current departure in search route is invalid
// 					// thus we need to set current the default origin as the fromValue and dispatch it to the searchroute
// 					if (!fromValue) {
// 						this.InitialOriginValue = this.INDRA_getAirportByCode(this.defaultOrigin, this.origins);
// 						fromValue = this.InitialOriginValue;
// 						this.store.dispatch(new MiniIBEActions.PutCurrentSearchRoute(index));
// 						this.store.dispatch(new MiniIBEActions.PutActiveInput(endpoint));
// 						this.store.dispatch(new MiniIBEActions.PutSearchRoute(this.InitialOriginValue));
// 					}

// 					this.form.get(endpoint).setValue(fromValue);
// 					this.store.dispatch(new MiniIBEActions.PutCurrentSearchRoute(index));
// 					this.store.dispatch(new MiniIBEActions.PutActiveInput(endpoint));
// 					this.store.dispatch(new MiniIBEActions.PutSearchRoute(fromValue));

// 					if ((this.INDRA_stopoverIsAdded() && this.loadStopover && this.storedStopOver && this.routeType === TRIP_TYPE_ROUND_TRIP) ||
// 						(this.INDRA_stopoverIsAdded() && this.routeType === TRIP_TYPE_ROUND_TRIP && this.bfmDataStorage.INDRA_getStopoverOutboundDate())) {
						
// 						const searchRouteClone = _.cloneDeep(fromValue);
// 						if (this.bfmDataStorage.INDRA_getStopoverOutboundDate() && this.bfmDataStorage.INDRA_getStopoverOutboundDate()[0]) {
// 							this.storedDepartureDate = this.bfmDataStorage.INDRA_getStopoverOutboundDate();
// 						}

// 						// if stopover is for RT and user navigates to other routeType and back,
// 						// push arrival date back to stopover on redux
// 						searchRouteClone.date = this.storedDepartureDate[0];
// 						this.store.dispatch(new MiniIBEActions.PutSearchRoute(searchRouteClone));
// 						this.storedDepartureDate = null;
						
// 					} else if ((this.INDRA_stopoverIsAdded() && this.loadStopover && this.storedStopOver && this.routeType === TRIP_TYPE_ONE_WAY) ||
// 						(this.INDRA_stopoverIsAdded() && this.routeType === TRIP_TYPE_ONE_WAY && this.bfmDataStorage.INDRA_getOneWayStopoverOutboundDate())) {
						
// 						const searchRouteClone = _.cloneDeep(fromValue);
// 						if (this.bfmDataStorage.INDRA_getOneWayStopoverOutboundDate() && this.bfmDataStorage.INDRA_getOneWayStopoverOutboundDate()[0]) {
// 							this.storedOWDepartureDate = this.bfmDataStorage.INDRA_getOneWayStopoverOutboundDate();
// 						}

// 						// if stopover is for oneway and user navigates to other routeType and back,
// 						// push arrival date back to stopover on redux
// 						searchRouteClone.date = this.storedOWDepartureDate[0];
// 						this.store.dispatch(new MiniIBEActions.PutSearchRoute(searchRouteClone));
// 						this.storedOWDepartureDate = null;
// 					}

// 					this.INDRA_fetchDestinationForNonMulticity();
// 				} else {
// 					// otherwise, default origin from API will be set..
// 					defaultAirportForEndpoint = this.INDRA_getAirportByCode(this.defaultOrigin, this.origins);
// 					this.InitialOriginValue = defaultAirportForEndpoint;
// 					this.form.get(endpoint).setValue(defaultAirportForEndpoint);
// 					this.store.dispatch(new MiniIBEActions.PutCurrentSearchRoute(index));
// 					this.store.dispatch(new MiniIBEActions.PutActiveInput(endpoint));
// 					this.store.dispatch(new MiniIBEActions.PutSearchRoute(defaultAirportForEndpoint));
// 					if (defaultAirportForEndpoint) {
// 						this.INDRA_fetchDestinationForNonMulticity();
// 					}
// 				}
// 			}
// 		} else {
// 			// setting of initial value for destination field..
// 			if (this.form.get('routeType').value === TRIP_TYPE_MULTICITY) {
// 				// If there's any selected input from previous steps, it will be copied on the rows of M trip..
// 				if (this.seachRoute[index] && this.seachRoute[index].arrival ) {
// 					let multicityToValue = this.INDRA_getAirportByCode(
// 						this.seachRoute[index].arrival.code, this.multicityDestinations[index]);

// 					if (indexForm) {
// 						const eligibleForAwardRoute =
// 						this.bookingSearchService.INDRA_getAirportAwardBookingEligibility(multicityToValue);
// 						const eligibleForCommercialRoute =
// 							this.bookingSearchService.INDRA_getAirportCommercialBookingEligbility(multicityToValue);

// 						// Only set the destination to form IF it is eligible for the type of booking.
// 						// if pay with miles = true, it should be eligible for award booking;
// 						// if pay with miles = false, it should be eligible for commercial booking;
// 						// Note: This check is needed since we are calling origin and destination list
// 						//       everytime we check/uncheck pay with miles checkbox.
// 						if ((!eligibleForAwardRoute && this.bookAwardFlights) ||
// 							(!eligibleForCommercialRoute && !this.bookAwardFlights)) {
// 							// since not eligible, reset the search route
// 							this.form.get(endpoint).setValue(null);
// 							this.store.dispatch(new MiniIBEActions.PutCurrentSearchRoute(index));
// 							this.store.dispatch(new MiniIBEActions.PutActiveInput(endpoint));
// 							this.store.dispatch(new MiniIBEActions.PutSearchRoute(null));

// 							multicityToValue = null;
// 						} else {
// 							this.form.get(endpoint).setValue(multicityToValue);
// 							this.store.dispatch(new MiniIBEActions.PutCurrentSearchRoute(index));
// 							this.store.dispatch(new MiniIBEActions.PutActiveInput(endpoint));
// 							this.store.dispatch(new MiniIBEActions.PutSearchRoute(multicityToValue));
// 						}
// 					}
// 					if (multicityToValue) {
// 						this.INDRA_fetchOriginForMulticity(index + 1);
// 					} else {
// 						// reset succeeding rows since destination field of current row is NULL
// 						const formArraySize = (this.form.controls['flights'] as FormArray).length;
// 						for (let i = index + 1; i <= formArraySize - 1; i++) {
// 							const nextform = (this.form.controls['flights'] as FormArray).at(i);
// 							if (nextform) {
// 								this.multicityOrigins[i] = [];
// 								this.multicityDestinations[i] = [];
// 								nextform.get('from').setValue(null);
// 								nextform.get('to').setValue(null);
// 								this.store.dispatch(new MiniIBEActions.PutCurrentSearchRoute(i));
// 								this.store.dispatch(new MiniIBEActions.PutActiveInput('from'));
// 								this.store.dispatch(new MiniIBEActions.PutSearchRoute(null));
// 								this.store.dispatch(new MiniIBEActions.PutActiveInput('to'));
// 								this.store.dispatch(new MiniIBEActions.PutSearchRoute(null));
// 								this.store.dispatch(new MiniIBEActions.PutActiveInput('date'));
// 								this.store.dispatch(new MiniIBEActions.PutSearchRoute(null));
// 							}
// 						}
// 					}
// 				} else {
// 					// otherwise, default destination from API will be set..
// 					defaultAirportForEndpoint = this.INDRA_getAirportByCode(
// 						this.defaultMulticityDestinations[index], this.multicityDestinations[index]);

// 					if (indexForm) {
// 						indexForm.get(endpoint).setValue(defaultAirportForEndpoint);
// 						this.store.dispatch(new MiniIBEActions.PutCurrentSearchRoute(index));
// 						this.store.dispatch(new MiniIBEActions.PutActiveInput(endpoint));
// 						this.store.dispatch(new MiniIBEActions.PutSearchRoute(defaultAirportForEndpoint));
// 					}
// 					if (defaultAirportForEndpoint) {
// 						this.INDRA_fetchOriginForMulticity(index + 1);
// 					}
// 				}
// 			} else {
// 				// If there's any selected input from previous steps, it will be copied RT/OW origin..
// 				if (this.seachRoute[index] && this.seachRoute[index].arrival) {
// 					const toValue = this.INDRA_getAirportByCode(this.seachRoute[index].arrival.code, this.destinations);
// 					const eligibleForAwardRoute =
// 						this.bookingSearchService.INDRA_getAirportAwardBookingEligibility(toValue);
// 					const eligibleForCommercialRoute =
// 						this.bookingSearchService.INDRA_getAirportCommercialBookingEligbility(toValue);

// 					// Only set the destination to form IF it is eligible for the type of booking.
// 					// if pay with miles = true, it should be eligible for award booking;
// 					// if pay with miles = false, it should be eligible for commercial booking;
// 					// Note: This check is needed since we are calling origin and destination list
// 					//       everytime we check/uncheck pay with miles checkbox.
// 					if ((!eligibleForAwardRoute && this.bookAwardFlights) ||
// 						(!eligibleForCommercialRoute && !this.bookAwardFlights)) {
// 						// since not eligible, reset the search route
// 						this.form.get(endpoint).setValue(null);
// 						this.store.dispatch(new MiniIBEActions.PutCurrentSearchRoute(index));
// 						this.store.dispatch(new MiniIBEActions.PutActiveInput(endpoint));
// 						this.store.dispatch(new MiniIBEActions.PutSearchRoute(null));
// 					} else {
// 						this.form.get(endpoint).setValue(toValue);
// 						this.store.dispatch(new MiniIBEActions.PutCurrentSearchRoute(index));
// 						this.store.dispatch(new MiniIBEActions.PutActiveInput(endpoint));
// 						this.store.dispatch(new MiniIBEActions.PutSearchRoute(toValue));

// 						if (this.INDRA_stopoverIsAdded() && this.loadStopover && this.storedStopOver && this.routeType === TRIP_TYPE_ROUND_TRIP ||
// 							this.INDRA_stopoverIsAdded() && this.routeType === TRIP_TYPE_ROUND_TRIP && this.bfmDataStorage.INDRA_getStopoverInboundDate()
// 							) {
// 							const searchRouteClone = _.cloneDeep(toValue);

// 							if (this.bfmDataStorage.INDRA_getStopoverInboundDate()[0]) {
// 								this.storedArrivalDate = this.bfmDataStorage.INDRA_getStopoverInboundDate();
// 							}

// 							// if stopover is for RT and user navigates to other routeType and back,
// 							// push arrival date back to stopover on redux
// 							searchRouteClone.date = this.storedArrivalDate[0];
// 							this.store.dispatch(new MiniIBEActions.PutSearchRoute(searchRouteClone));
// 							this.storedArrivalDate = null;
// 						}
// 					}
// 				} else {
// 					// otherwise, default destination from API will be set..
// 					defaultAirportForEndpoint = this.INDRA_getAirportByCode(this.defaultDestination, this.destinations);
// 					this.form.get(endpoint).setValue(defaultAirportForEndpoint);
// 					this.store.dispatch(new MiniIBEActions.PutCurrentSearchRoute(index));
// 					this.store.dispatch(new MiniIBEActions.PutActiveInput(endpoint));
// 					this.store.dispatch(new MiniIBEActions.PutSearchRoute(defaultAirportForEndpoint));
// 				}
// 			}
// 		}
// 	}

// 	INDRA_getAirportByCode(code: string, airportList: INDRAAirport[]): INDRAAirport {
// 		let returnValue: INDRAAirport = null;
// 		if (airportList && airportList.length > 0) {
// 			returnValue = airportList.find(airport => airport.code == code);
// 		}
// 		return returnValue;
// 	}

// 	INDRA_fetchDestinationForNonMulticity(isSwapping?: boolean) {
// 		console.log('INDRA_fetchDestinationForNonMulticity')
// 		this.isDestinationLoading = true;
// 		this.journeyRequestParam.tripType = this.form.get('routeType').value;
// 		this.journeyRequestParam.origin = this.form.get('from').value.code;
// 		this.journeyRequestParam.payWithMiles = this.isPayWithMilesRoute;
// 		this.resetValuesCompleted$.subscribe((completed) => {
// 			if (completed) {
// 				this.destinationSubscription =
// 				this.airportService.IndraGetDestinations(this.journeyRequestParam).subscribe(
// 					(response: INDRABFMJourneyDestinationResponse) => {
// 						if (response && response.data && response.status === '200') {
// 							// this instantiation involves massaging of data to meet the data structure
// 							// expected on the airport input component
// 							const deatinationDataRecon = new INDRADestinationDataRecon(response);
// 							const data: INDRADestinations = deatinationDataRecon.data;
// 							if (data.destinations && data.destinations.length > 0) {
// 								this.destinations = data.destinations;
// 								this.defaultDestination = data.default;
// 								/* if (!isSwapping) */ // commented to allow setting the destination airport even in swap scenario
// 								this.INDRA_setInitialAirportValue('to');
// 							}
// 						}
// 						this.isDestinationLoading = false;
// 				}, error => {
// 					this.isDestinationLoading = false;
// 				});
				
// 				if (this.destinationSubscription) {
// 					this.allSubscription.push(this.destinationSubscription);
// 				}
// 			}
// 		});

// 	}

// 	INDRA_fetchDestinationForMulticity(index: number = 0, isSwapping?: boolean) {
// 		this.isMulticityDestinationLoading[index] = true;
// 		const form = (this.form.controls['flights'] as FormArray).at(index);
// 		this.journeyRequestParam.origin =
// 			form.get('from').value ? form.get('from').value.code : this.seachRoute[index].departure.code;
// 		this.journeyRequestParam.tripType = TRIP_TYPE_MULTICITY;
// 		this.journeyRequestParam.payWithMiles = this.isPayWithMilesRoute;

// 		// Reset next multicity rows only during manual inputs
// 		// (during automatic loading, it should not reset the previous values for the next multicity rows)
// 		if (!this.multicityRoutesPersistScenario) {
// 			// resets dataOptions and values for the succeeding indices/rows..
// 			const formArraySize = (this.form.controls['flights'] as FormArray).length;
// 			for (let i = index + 1; i <= formArraySize - 1; i++) {
// 				const nextform = (this.form.controls['flights'] as FormArray).at(i);
// 				if (nextform) {
// 					this.multicityOrigins[i] = [];
// 					this.multicityDestinations[i] = [];
// 					nextform.get('from').setValue(null);
// 					nextform.get('to').setValue(null);
// 					this.store.dispatch(new MiniIBEActions.PutCurrentSearchRoute(i));
// 					this.store.dispatch(new MiniIBEActions.PutActiveInput('from'));
// 					this.store.dispatch(new MiniIBEActions.PutSearchRoute(null));
// 					this.store.dispatch(new MiniIBEActions.PutActiveInput('to'));
// 					this.store.dispatch(new MiniIBEActions.PutSearchRoute(null));
// 					this.store.dispatch(new MiniIBEActions.PutActiveInput('date'));
// 					this.store.dispatch(new MiniIBEActions.PutSearchRoute(null));
// 				}
// 			}
// 		}

// 		// brings back CurrentSearchRoute to the correct index after clearing succeeding indices/rows
// 		this.store.dispatch(new MiniIBEActions.PutCurrentSearchRoute(index));

// 		this.resetValuesCompleted$.subscribe((completed) => {
// 			if (completed) {
// 				this.destinationSubscription =
// 				this.airportService.IndraGetDestinations(this.journeyRequestParam)
// 				.subscribe((response: INDRABFMJourneyDestinationResponse) => {
// 					if (response && response.data && response.status === '200') {
// 						// this instantiation involves massaging of data to meet the data structure expected on the airport input component
// 						const deatinationDataRecon = new INDRADestinationDataRecon(response);
// 						const data: INDRADestinations = deatinationDataRecon.data;
// 						if (data.destinations && data.destinations.length > 0) {
// 							this.multicityDestinations[index] = data.destinations;
// 							this.defaultMulticityDestinations[index] = data.default;
// 							if (!isSwapping) {
// 								this.INDRA_setInitialAirportValue('to', index);
// 							} else {
// 								this.INDRA_fetchOriginForMulticity(index + 1);
// 							}
// 						}
// 					}
// 					this.isMulticityDestinationLoading[index] = false;
// 				}, error => {
// 					this.isMulticityDestinationLoading[index] = false;
// 				});
				
// 				if (this.destinationSubscription) {
// 					this.allSubscription.push(this.destinationSubscription);
// 				}
// 			}
// 		})

// 	}

// 	INDRA_createBookingParams() {
// 		this.journeyRequestParam = {
// 			tripType: DEFAULT_TRIP_TYPE,
// 			market: sessionStorage.getItem(SESSION_VAR_KEY_MARKET) ?
// 				sessionStorage.getItem(SESSION_VAR_KEY_MARKET) : DEFAULT_MARKET,
// 			language: this.language,
// 			airlineIds: DEFAULT_AIRLINE_IDS,
// 			payWithMiles: false
// 		};
// 	}

// 	INDRA_removeAdditionalMulticityRoutes() {
// 		if (this.form) {
// 			const multicityRouteFormCount = (this.form.controls['flights'] as FormArray).length;
// 			// delete route/s in form
// 			while ((this.form.controls['flights'] as FormArray).length > 2) {
// 				(this.form.controls['flights'] as FormArray).removeAt(2);
// 			}

// 			// override the search route in store with the remaining routes from form to remove
// 			// corresponding route/s that was deleted from the form
// 			const flights = this.form.controls['flights'].value.map(cur =>
// 				({ departure: cur.from, arrival: cur.to, date: this.INDRA_adjustmentDate(cur.date) }));

// 			this.store.dispatch(new MiniIBEActions.PutActiveInput(null));
// 			this.store.dispatch(new MiniIBEActions.PutSearchRoute(flights));
// 		}
// 	}

// 	INDRA_toggleVoucherPromocodes(bookAward: boolean) {
// 		const completePromocodeVoucherList = this.promocodesAndVouchers.map(x => { return {...x}; });

// 		completePromocodeVoucherList.forEach(discount => {
// 			if ((bookAward && (discount.currencyCode === 'M' || discount.type === DISCOUNT_TYPE_VOUCHER)) || (!bookAward && discount.currencyCode !== 'M')) {
// 				discount.status = DISCOUNT_STATUS_ACTIVE;
// 			} else {
// 				discount.status = DISCOUNT_STATUS_INACTIVE;
// 			}
// 			/*
// 			if (bookAward && discount.type === DISCOUNT_TYPE_VOUCHER) {
// 				discount.status = DISCOUNT_STATUS_INACTIVE;
// 			}
// 			*/
// 		});
		
// 		const activeDiscounts = completePromocodeVoucherList.filter(discount => discount.status === DISCOUNT_STATUS_ACTIVE);
// 		const inactiveDiscounts = completePromocodeVoucherList.filter(discount => discount.status === DISCOUNT_STATUS_INACTIVE);

// 		if (completePromocodeVoucherList.length > 0) {
// 			this.store.dispatch(new PromoVouchersActions.PutPromoVouchersAction(completePromocodeVoucherList));
			
// 			if (activeDiscounts.length > 0) {
// 				completePromocodeVoucherList.forEach(discount => {
// 					if (discount.type === DISCOUNT_TYPE_VOUCHER) {
// 						this.discountService.validateVoucherPromoCode({voucher: discount.code}, DISCOUNT_TYPE_VOUCHER);
// 					} else {
// 						this.discountService.validateVoucherPromoCode(discount.code, DISCOUNT_TYPE_PROMOCODE, this.bookAwardFlights);
// 					}
// 				});
// 			} 
			
// 			if (inactiveDiscounts.length > 0) {
// 				inactiveDiscounts.forEach(discount => {
// 					if (discount.type === DISCOUNT_TYPE_PROMOCODE) {
// 						this.discountService.INDRA_removePromoCodeInSession(discount.code);
// 					} else {
// 						this.discountService.INDRA_removeVoucherInSession(discount.code);
// 					}
// 				});
// 			}
// 		}
// 	}

// 	INDRA_stopoverIsAdded() {
// 		return this.form.controls['stopovers'].value.length > 0;
// 	}

// 	INDRA_getDatePickerOptions(index) {
// 		this.datepickerOptions.dateFormat = this.dateService.INDRA_getDateFormat().toLowerCase();

// 		const newDatepickerOptions: IMyDpOptions = Object.assign({}, this.datepickerOptions);
// 		newDatepickerOptions.ariaLabelInputField = this.INDRA_getTranslationKey('bookingSearch.aria.selectDateForFlight') + (index + 1);
// 		return newDatepickerOptions;
// 	}

// 	INDRA_getTranslationKey(key: string): string {
// 		return this.ibeAdminService.getTranslationValue(key);
// 	}


// 	async INDRA_navigate() {
// 		if (this.form.valid) {
// 			this.loading = true;
// 			const formValues = this.form.value;
			
// 			this.store.dispatch(new MiniIBEActions.PutActiveInput(null));
// 			this.store.dispatch(new MiniIBEActions.PutPassengers(formValues['passengers']));
			
// 			if (sessionStorage) {
// 				sessionStorage.setItem(SESSION_VAR_KEY_PASSENGERS, JSON.stringify(formValues['passengers']));
// 			}

// 			await this.bookingStepsEffects.createBookingSteps(formValues, this.bookedTripDiscounts);
// 			this.INDRA_registerGAFlightSearch();
			
// 			if (formValues.stopovers.length) {
// 				this.router.navigate(['./flights-stopover'], { relativeTo: this.route });
// 			} else {
// 				if (formValues.routeType == TRIP_TYPE_MULTICITY) {
// 					const flights = this.form.controls['flights'].value.map(
// 						cur => ({ departure: cur.from, arrival: cur.to, date: this.INDRA_adjustmentDate(cur.date) }));
// 					this.store.dispatch(new MiniIBEActions.PutSearchRoute(flights));
// 					if (localStorage) {
// 						// saves the 1st row of the flight on local storage..
// 						localStorage.setItem(SESSION_VAR_KEY_SEARCH_ROUTE, JSON.stringify(flights[0]));
// 					}
					
// 					if (this.router.url.includes('/main/deeplink')) {
// 						this.router.navigate(['/booking/flights-multicity']);
// 					} else {
// 						this.router.navigate(['./flights-multicity'], { relativeTo: this.route });
// 					}
// 				} else {
// 					if (formValues['to'] instanceof Object && formValues['from'] instanceof Object) {
// 						this.store.dispatch(new MiniIBEActions.PutSearchRoute(
// 							Object.assign([{ departure: formValues['from'], arrival: formValues['to'], date: null }])));
// 						if (localStorage) {
// 							localStorage.setItem('SearchRoute',
// 								JSON.stringify({ departure: formValues['from'], arrival: formValues['to'], date: null }));
// 						}
// 						if ('type' in formValues['to'] || 'type' in formValues['from']) {
// 							this.router.navigate(['./trip-finder'], { relativeTo: this.route });
// 						} else {
// 							// Go to flights page if there are dates provided
// 							if (this.selectedRangeDates && this.selectedRangeDates.length > 0) {
// 								const steps = [...this.bookingSteps];
// 								const auxArray: Array<BookingStep> = [];
// 								if (this.bookingSteps.length > 1) {
// 									auxArray.push(
// 										Object.assign(new BookingStep(null, null), steps[0], {
// 											_date: this.selectedRangeDates[0],
// 											date_selected: false,
// 										})
// 									);
// 									auxArray.push(
// 										Object.assign(new BookingStep(null, null), steps[1], {
// 											_date: this.selectedRangeDates[1],
// 											date_selected: false,
// 										})
// 									);
// 								} else {
// 									auxArray.push(
// 										Object.assign(new BookingStep(null, null), steps[0], {
// 											_date: this.selectedRangeDates[0],
// 											date_selected: false,
// 										})
// 									);
// 								}

// 								this.store.dispatch(new BookingStepsActions.PutStepsAction(auxArray));
// 								this.store.dispatch(new BookingStepsActions.PutCurrentPageAction('flights'));
// 								this.router.navigate(['./flights'], { relativeTo: this.route });
// 							} 
// 						}
// 					} else {
// 						this.loading = false;
// 					}
// 				}
// 			}

// 		}
// 	}

// 	private INDRA_registerGAFlightSearch() {
// 		const origin = this.googleAnalytics.IBE_getOriginAirport();
// 		const dest = this.googleAnalytics.IBE_getDestinationAirport();
// 		const flightCode = `${origin.code}-${dest.code}`;
// 		const flightName = `${origin.code}-${dest.code}`;
// 		const eventDataLayerObject = this.googleAnalytics.IBE_createGA_FlightProducts(flightCode, flightName);
// 		eventDataLayerObject.actionField = this.googleAnalytics.INDRA_createGA_ActionField(EVENT_ACTION_CLICK);
// 		this.googleAnalytics.INDRA_GA_productClick(eventDataLayerObject, sessionStorage.getItem(SESSION_VAR_KEY_CURRENCY));
// 	}
// }
